'use strict'
export const labels = {
  ko: {
    title: '성우와 초코민트',
    add: '신규 등록',
    search_input: '성우 이름으로 검색...',
    search: '검색',
    login: '트위터로 로그인',
    logout: '로그아웃',
    filter0: '전체',
    filter1: '좋아함',
    filter2: '싫어함',
    filter3: '무관심',
    filter4: '보통',
    filter5: '알수없음',
    search1: '전체 등록 성우 수',
    search2: '명, 검색 결과',
    search3: '건',
    keyword: '키워드',
    name: '이름',
    chocomint: '초코민트',
    chocomint_info: '초코민트 정보',
    company: '소속사',
    regdt: '갱신일자',
    details: '상세',
    edit: '수정',
    remove: '삭제',
    share_tweet: '트위터에 공유',
    comment1: '초코민트를 좋아합니다.',
    comment2: '초코민트를 싫어합니다.',
    comment3: '초코민트에 딱히 관심이 없었습니다.',
    comment4: '초코민트를 딱히 좋아하지도 싫어하지도 않습니다.',
    comment5: '알 수 없습니다.',
    edit_person: '최종 수정자',
    edits: '수정 이력',
    tweet_sama: '님은 ',
    error: '시스템 에러가 발생했습니다. 관리자에게 문의해주세요.',
    confirm_remove: '정말로 본 정보를 삭제하시겠습니까? 삭제는 중복된 성우 정보 등에만 사용해주세요.',
    remove_complete: '본 초코민트 정보가 정상적으로 삭제되었습니다.',
    error_permission: '초코민트 정보의 등록 및 수정은 트위터로 로그인한 유저만 가능합니다.',
    error_notweet: '트윗이 올바르지 않습니다.',
    error_info: '정보가 정상적으로 전달되지 않았습니다.',
    error_intweet: '트윗이 등록되지 않았습니다.',
    tweet: '트윗하기',
    tweeting: '트윗중...',
    form_name: '성우 이름',
    form_name_ja: '성우 이름(일본어)',
    form_name_ko: '성우 이름(한국어)',
    form_office: '소속사',
    form_office_ja: '소속사(일본어)',
    form_office_ko: '소속사(한국어)',
    form_office_select: '또는 선택지에서 고르기',
    form_profile_url: '프로필 이미지 URL',
    form_profile_comment: '공식 사이트에 개제된 사진이나, 공개 가능한 일러스트의 URL 등을 입력해주세요. 직접 업로드는 안됩니다 ㅠ',
    form_memo: '추가 메모',
    form_memo_comment: '관련 트위터/블로그 등의 URL등, 증거가 되는 정보를 적어주세요.',
    form_add: '등록',
    form_adding: '등록중...',
    form_err_name: '성우 이름(일본어)는 필수로 입력해주셔야 합니다.',
    form_err_chocomint: '초코민트 정보를 입력해주세요.',
    form_confirm: '본 내용으로 초코민트 정보를 등록하시겠습니까?',
    form_err_login: '초코민트 정보의 등록 및 수정은 트위터로 로그인한 유저만 가능합니다.',
    form_err_required: '필수 정보를 입력해주세요.',
    form_err_duplicate: '해당 이름의 성우가 이미 등록되어 있습니다. 등록 내역을 한 번 확인해주세요.',
    form_success: '초코민트의 정보가 정상적으로 등록되었습니다.',
    form_remove_confirm: '정말로 본 정보를 삭제하시겠습니까? 삭제는 중복된 성우 정보 등에만 사용해주세요.',
    form_remove_success: '본 초코민트 정보가 정상적으로 삭제되었습니다.',
    hashtag: '#성우와초코민트',
  },
  ja: {
    title: '声優とチョコミント',
    add: '新規登録',
    search_input: '声優の名前で検索...',
    search: '検索',
    login: 'Twitterでログイン',
    logout: 'ログアウト',
    filter0: '全て',
    filter1: '好き',
    filter2: '嫌い',
    filter3: '無関心',
    filter4: '普通',
    filter5: '分からない',
    search1: '登録声優数',
    search2: '名, 検索結果',
    search3: '件',
    keyword: 'キーワード',
    name: '氏名',
    chocomint: 'チョコミント',
    chocomint_info: 'チョコミント情報',
    company: '事務所',
    regdt: '更新日時',
    details: '詳細',
    edit: '編集',
    remove: '削除',
    share_tweet: 'ツイッターにシェアー',
    comment1: 'チョコミントが好きです。',
    comment2: 'チョコミントが嫌いです。',
    comment3: 'チョコミントに特に興味がありません。',
    comment4: 'チョコミントに特に好き嫌いはありません。',
    comment5: '分かりません。',
    edit_person: '最終編集者',
    edits: '編集履歴',
    tweet_sama: 'さんは',
    error: 'システムエラーが発生しました、お手数ですが管理者にお問い合わせお願いします。',
    confirm_remove: '本当にこの情報を削除致しますか？',
    remove_complete: 'チョコミント情報が削除されました。',
    error_permission: '本情報の修正及び削除の権限はログインされたユーザーのみ可能になっております。',
    error_notweet: 'ツイートが正しくありません。',
    error_info: '情報が正しく処理されておりません。',
    error_intweet: 'ツイートが登録されていません。',
    tweet: 'ツイート',
    tweeting: 'ツイート中…',
    form_name: '声優さんのお名前',
    form_name_ja: '声優さんのお名前',
    form_name_ko: '声優さんのお名前',
    form_office: '事務所名',
    form_office_ja: '事務所名',
    form_office_ko: '事務所名',
    form_office_select: '選択肢から選ぶ',
    form_profile_url: 'プロフィール画像URL',
    form_profile_comment: '公式サイト掲載の写真のURLや、その他の公開可能なURLを入力してください。画像アップロード機能は今後追加します…',
    form_memo: 'メモ',
    form_memo_comment: '証拠のツイッター/ブログ等のURL等を入力してください。',
    form_add: '登録',
    form_adding: '登録中...',
    form_err_name: '声優さんのお名前は必須で入力してください。',
    form_err_chocomint: 'チョコミントの情報を入力してください。',
    form_confirm: 'この内容でチョコミント情報を登録しますか？',
    form_err_login: 'チョコミント情報の修正はツイッターでログインされた方のみできます。',
    form_err_required: '必須情報を入力してください。',
    form_err_duplicate: 'この名前の声優さんの情報は既に登録されています。登録一覧をもう一度確認してみてください。',
    form_success: 'チョコミントの情報が登録されました。',
    form_remove_confirm: '本当にこのチョコミントの情報を削除しますか？',
    form_remove_success: 'チョコミント情報が削除されました。',
    hashtag: '#声優とチョコミント',
  },
}